import { AzureChatOpenAI } from "@langchain/openai";
import { SystemMessage, HumanMessage } from "@langchain/core/messages";

import { ErrorDetail, getPrompt, Metadata } from "./prompt-generator.js";
import { getConfig, DEPLOYMENT, API_VERSION } from "./config.js";

export const invokeLlm = async (
  metadata: Metadata,
  similarCases?: string[],
  error?: ErrorDetail,
): Promise<void> => {
  const { DIAL_API_KEY, DIAL_PROXY_URL } = await getConfig();

  const API_BASE_PATH = `https://${DIAL_PROXY_URL}/openai/deployments/${DEPLOYMENT}/chat/completions?api-version=${API_VERSION}`;

  const llm = new AzureChatOpenAI({
    azureOpenAIApiKey: DIAL_API_KEY,
    azureOpenAIApiVersion: "2024-07-01-preview",
    azureOpenAIBasePath: API_BASE_PATH,
    temperature: 1.0,
    maxTokens: undefined,
    timeout: undefined,
    maxRetries: 1,
  });

  const systemMessage = new SystemMessage("Be creative");
  const userMessage = new HumanMessage(
    getPrompt(metadata, similarCases, error),
  );

  const messages = [systemMessage, userMessage];

  console.log("Running agent...");
  try {
    const response = await llm.invoke(messages);
    console.log("LLM Response:", response.content);
  } catch (err) {
    console.error("Error during LLM execution:", err);
  }
};
